module.exports = __webpack_public_path__ + "img/img10.9a95b161.svg";